import { User } from '../types';

const API_BASE_URL = 'https://class.hiresuperior.com/api';

export const apiAuthService = {
  async login(email: string, password: string): Promise<User & { requiresPasswordChange?: boolean }> {
    const response = await fetch(`${API_BASE_URL}/login.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ email, password }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Login failed');
    }

    const userData = await response.json();
    
    return {
      id: userData.id,
      username: userData.email,
      email: userData.email,
      name: userData.name,
      role: 'teacher', // Default to teacher for now, will be updated based on user data
      isAuthenticated: true,
      lastLogin: new Date(),
      requiresPasswordChange: userData.requiresPasswordChange,
    };
  },

  async changePassword(currentPassword: string, newPassword: string): Promise<void> {
    const response = await fetch(`${API_BASE_URL}/change-password.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ currentPassword, newPassword }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Password change failed');
    }
  },

  async getCurrentUser(): Promise<User | null> {
    try {
      const response = await fetch(`${API_BASE_URL}/me.php`, {
        method: 'GET',
        credentials: 'include',
      });

      if (!response.ok) {
        return null;
      }

      const userData = await response.json();
      
      return {
        id: userData.id,
        username: userData.email,
        email: userData.email,
        name: userData.name,
        role: userData.role || 'teacher',
        studentId: userData.studentId,
        isAuthenticated: true,
        lastLogin: new Date(userData.lastLogin),
      };
    } catch (error) {
      console.error('Error getting current user:', error);
      return null;
    }
  },

  async logout(): Promise<void> {
    try {
      await fetch(`${API_BASE_URL}/logout.php`, {
        method: 'POST',
        credentials: 'include',
      });
    } catch (error) {
      console.error('Logout error:', error);
    }
  },
};
